module.exports = __webpack_public_path__ + "static/media/gryphon_musee_ids_loom_1.a38f8db9.jpg";